import React from 'react';
import CopyIcon from '../../../icons/general/CopyIcon';
import type { PixEmvSectionProps } from '../types/pix-payment.types';

const PixEmvSection: React.FC<PixEmvSectionProps> = ({ emv, onCopyEmv, emvCopied }) => {
  return (
    <div className="flex flex-col lg:w-1/2 items-center lg:items-start lg:hidden">
      <button
        onClick={onCopyEmv}
        className="w-full flex items-center justify-center bg-primary text-white font-semibold py-3 px-4 rounded-lg hover:bg-primary-dark transition duration-150 text-base mb-6"
        aria-label="Copiar código PIX"
      >
        <CopyIcon className="w-5 h-5 mr-2" />
        {emvCopied ? 'Copiado!' : 'Copiar Código'}
      </button>
      <div className="w-full p-4 border border-medium-gray dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 mb-3">
        <p className="text-sm text-text-secondary dark:text-gray-300 break-all whitespace-pre-wrap font-mono" aria-label="Código PIX Copia e Cola">
          {emv}
        </p>
      </div>
    </div>
  );
};

export default PixEmvSection; 